// Client-side "share before/after" composition: the two images side by
// side with BEFORE/AFTER labels and a plain photorealify.com wordmark.
// Both sources are same-origin blob URLs (fetched through the API client),
// so the canvas stays untainted and toBlob works everywhere.

const PANEL_MAX_HEIGHT = 1080;
const BACKGROUND = "#101014";

function loadImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error("Share image failed to load"));
    image.src = url;
  });
}

function pill(ctx, text, x, y, fontSize) {
  ctx.font = "700 " + fontSize + "px Inter, Arial, sans-serif";
  const padX = Math.round(fontSize * 0.7);
  const width = ctx.measureText(text).width + padX * 2;
  const height = Math.round(fontSize * 1.8);
  ctx.fillStyle = "rgba(0, 0, 0, 0.55)";
  ctx.fillRect(x, y, width, height);
  ctx.fillStyle = "#ffffff";
  ctx.textBaseline = "middle";
  ctx.fillText(text, x + padX, y + height / 2 + fontSize * 0.06);
}

export async function composeBeforeAfter(beforeUrl, afterUrl) {
  const [before, after] = await Promise.all([loadImage(beforeUrl), loadImage(afterUrl)]);
  const height = Math.min(PANEL_MAX_HEIGHT, after.naturalHeight || PANEL_MAX_HEIGHT);
  const beforeWidth = Math.max(1, Math.round(before.naturalWidth * (height / before.naturalHeight)));
  const afterWidth = Math.max(1, Math.round(after.naturalWidth * (height / after.naturalHeight)));
  const gap = Math.max(2, Math.round(height / 270));

  const canvas = document.createElement("canvas");
  canvas.width = beforeWidth + gap + afterWidth;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = BACKGROUND;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(before, 0, 0, beforeWidth, height);
  ctx.drawImage(after, beforeWidth + gap, 0, afterWidth, height);

  const fontSize = Math.max(16, Math.round(height / 34));
  const margin = Math.round(fontSize * 0.8);
  pill(ctx, "BEFORE", margin, margin, fontSize);
  pill(ctx, "AFTER", beforeWidth + gap + margin, margin, fontSize);

  const markSize = Math.max(14, Math.round(height / 42));
  ctx.font = "600 " + markSize + "px Inter, Arial, sans-serif";
  const mark = "photorealify.com";
  const markWidth = ctx.measureText(mark).width;
  ctx.fillStyle = "rgba(0, 0, 0, 0.45)";
  ctx.fillRect(canvas.width - markWidth - margin * 2, canvas.height - markSize * 2 - margin / 2,
               markWidth + margin * 1.4, markSize * 1.8);
  ctx.fillStyle = "rgba(255, 255, 255, 0.92)";
  ctx.textBaseline = "middle";
  ctx.fillText(mark, canvas.width - markWidth - margin * 1.3,
               canvas.height - markSize * 1.1 - margin / 2 + markSize * 0.06);

  return new Promise((resolve, reject) => {
    canvas.toBlob(blob => (blob ? resolve(blob) : reject(new Error("Share image failed to render"))),
                  "image/jpeg", 0.9);
  });
}
